export default __webpack_public_path__ + "static/1947-6b4ebe0de2318ae2883cf51ca30f56ac.gif";